// extracted by mini-css-extract-plugin
module.exports = {"titleCase":"_40a2d46"};